// extracted by mini-css-extract-plugin
export var label = "_kr-2";
export var slideContainer = "_kr-0";
export var slider = "_kr-1";